import React from 'react';
import { Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

import { formatMoney } from '../../shared/formatters';

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: '12px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    marginRight: 0,
  },
}));

const StyledTable = styled(Table)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    minWidth: 'auto',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 98, 105, 0.04)',
  },
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: 'rgba(0, 98, 105, 0.05)',
  '& .MuiTableCell-head': {
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.938rem',
  fontWeight: 500,
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
}));

const MoneyCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.938rem',
  fontWeight: 500,
  padding: '16px',
  whiteSpace: 'nowrap',
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2, 2, 1, 2),
  fontWeight: 700,
  color: '#1a1a1a',
}));

const FutureResults = props => {
  const { result } = props;

  if (!result || !result.futureBalance)
    return null;

  const dateKeys = Object.keys(result.futureBalance);

  return (
    <StyledPaper>
      <SubTitle component="h3" variant="h6">
        Previsão
              </SubTitle>
      <StyledTable>
        <StyledTableHead>
          <TableRow>
            <StyledTableCell>
              Data
                    </StyledTableCell>
            <StyledTableCell align="right">
              Rendimento/Mês
                    </StyledTableCell>
            <StyledTableCell align="right">
              Aporte/Mês
                    </StyledTableCell>
            <StyledTableCell align="right">
              Saldo
                  </StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {(dateKeys || []).map(dateKey =>
            <StyledTableRow hover key={dateKey}>
              <StyledTableCell scope="row">
                {dateKey}
              </StyledTableCell>
              <MoneyCell align="right">{formatMoney(result.futureBalance[dateKey].difference)}</MoneyCell>
              <MoneyCell align="right">{formatMoney(result.averageDifference)}</MoneyCell>
              <MoneyCell align="right">{formatMoney(result.futureBalance[dateKey].balance)}</MoneyCell>
            </StyledTableRow>
          )}
        </TableBody>
      </StyledTable>
    </StyledPaper>
  );
};


export default FutureResults;